import {
  ReviewsServiceName,
  SelectedReview
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { Props as ControlCheckboxesProps } from "components/Critics/ControlCheckboxes"
import { Props as AddHomeVideoReviewActionsProps } from "components/HomeVideoReviews/AddActions"

import Add from "./Add"
import { Props as MainProps } from "./Main"

export interface Props {
  addHomeVideoReviewActionsProps: AddHomeVideoReviewActionsProps
  areReviewsLoading: boolean
  avForums: SelectedReview
  avNirvana: SelectedReview
  avsForum: SelectedReview
  bluRay: SelectedReview
  bluRayAuthority: SelectedReview
  digitalBits: SelectedReview
  doBlu: SelectedReview
  hidefDigest: SelectedReview
  highDefDiscNews: SelectedReview
  homeTheaterForum: SelectedReview
  mainProps: MainProps

  onClear: (serviceName: ReviewsServiceName) => () => void
  onSetReview: (
    serviceName: ReviewsServiceName
  ) => (overrides: SelectedReview["review"]) => void
  reviewsControlCheckboxesProps: ControlCheckboxesProps
  theaterByte: SelectedReview
  whySoBlu: SelectedReview
}

export interface ComponentProps extends Props {}

export default Add
